const authorBaseUrl = process.env.NEXT_PUBLIC_AUTHORBASEURL
const authorPreviewBaseUrl = process.env.NEXT_PUBLIC_PREVIEW_AUTHORBASEURL
const authorPreviewUserName = process.env.NEXT_PUBLIC_PREVIEW_USERNAME
const authorPreviewPassword = process.env.NEXT_PUBLIC_PREVIEW_PASSWORD
const previewContentPrefix = process.env.NEXT_PUBLIC_INTERNALLINKPATH
const publisherBaseUrl = process.env.NEXT_PUBLIC_PUBLISHERBASEURL
const baseUrl = process.env.NEXT_PUBLIC_BASEURL

const dataUrl = "/en.model.json"
const searchDataUrl = "/search.model.json"
const cartDataUrl = "/en/cart.model.json"
const headerUrl =
  "/content/experience-fragments/annsacks/us/en/navigation/header/header-experience-fragment/master2"
const footerUrl =
  "/content/experience-fragments/annsacks/us/en/navigation/footer/footer-experience-fragment/master"

const findashowroomUrl = "/find-a-showroom.model.json"
const cartPage = "cart"
const checkoutDataUrl = "/en/checkout.model.json"
const sharedCartUrl = "/en/cart/shared-cart.model.json"
const orderConfirmationDataUrl = "/en/orders/order-confirmation.model.json"
const orderDetailsPageDataUrl = "/en/orders/order-details.model.json"
const orderHistoryPageDataUrl = "/en/orders/order-history.model.json"
const orderStatusPageDataUrl = "/en/orders/order-status.model.json"
const PRODUCT_DATA_TILE_URL = `/p/tile-details.model.json`
const PRODUCT_DATA_TRIM_URL = `/p/trim-details.model.json`
const PRODUCT_TILE = `tile-details`
const PRODUCT_TRIM = `trim-details`

const MyProductsPageDataUrl = "/my-account/my-products.model.json"
const loveYourLookDataUrl = "/en/love-your-look.model.json"
const pageNotFoundDataUrl = "/en/error-handler-pages/404.model.json"
const apiBaseUrl = process.env.NEXT_PUBLIC_APIBASEURL
const oktaTokenEndpoint = "/oauth/token"
const getCartEndPoint = "/cart/active?expand=calculation"
const createCartEndPoint = "/cart/create"
const getStockEndPoint = "/catalog/inventory"
const cartItemsEndPoint = "/cart/v2/items"
const shippingCostEndPoint = "/checkout/shipping-cost"
const discountEndPoint = "cart/v2/discount?expand=calculation"
const taxEndPoint = "/cart/v2/items?expand=calculation"
const shareCartEndPoint = "/cart/sharedcart"
const mergeCartEndPoint = "/cart/merge?expand=calculation"
const signupEndPoint = "/customer/signup"
const deleteCartEndPoint = "/cart/v2/deleteActiveCart"
const shipmentFromCartEndPoint = "/checkout/v2/assign/shipmentfromcart"
const addAddressEndPoint = "/customer/address"
const addressSuggestionEndPoint = "/maps/address/validate"
const validateTokenEndPoint = "/oauth/token/validate"
const orderSubmitEndPoint = "/checkout/v2/order/submit"
const paymentEndPoint = "/checkout/payment"
const payPalPaymentEndPoint = "/payment/paypal/getToken"
const recentlyViewedEndPoint = "/catalog/product/projection"
const searchPlpEndPoint = "/search/plp"
const inPageSearchEndPoint = "/search/plp"
const searchProfilePlpEndPoint = "/search/profile"
const checkSplitOrderEndPoint = "/checkout/order-split-check"
export const searchPdpEndPoint = "/search/pdp"
export const pdpCatalogProjectionEndPoint = "/catalog/product/projection"
export const getPdpTooltipEndPoint = "/search/tooltip"
const accountSettingsPageDataUrl = "/my-account/account-settings.model.json"
const findAStoreUrl = "/locations/find-a-store.model.json"
const MY_PRODUCTS_ENDPOINT = "/shopping-list/MyProducts"
const FETCH_PRODUCT_REG_ENDPOINT = "/crm/fetchproductregistration"
const staticClasses = {
  CONTAINER: "container responsivegrid",
}
const productBySkuEndPoint = "/catalog/product/projection"
const MyServicePageDataUrl = "/my-account/my-services.model.json"
const MyFavoritesPageDataUrl = `/my-account/my-favorites.model.json`
const REGISTER_OFFLINE_PRODUCTS_DATA_URL = `/en/my-account/product-registration/register-offline-product.model.json`
const REGISTER_ONLINE_PRODUCTS_DATA_URL = `/en/my-account/product-registration/register-online-product.model.json`
const FAQ_PAGE_DATA_URL = "/support/help-and-faq"
const browseAllStoresURL = "/en/locations/browse-all-stores.model.json"
const LITERATURE_DATA_URL = "/en/for-professionals/literature.model.json"
const TECHNICAL_SPECIFICATION_DATA_URL =
  "/en/for-professionals/technical-specifications.model.json"
const PRESS_LANDING_URL = "/en/press-room.model.json"
const FIND_STORE_URL = "en/locations.model.json"
const ARTICLE_CONTENT_END_POINT = "/jcr:content.json"
const ARTICLE_IMG_END_POINT = "/jcr:content/image.json"
export const MY_LISTS_PAGE_PATH = "/my-account/my-lists"
export const MY_ACCOUNT_MODAL = "my account modal section"
export const CREATE_ACCOUNT = "create account"

const CONSTANTS = {
  DEFAULT_IDLE_TIMEOUT: 172800, // In Seconds
  DEFAULT_VERSION: "v1",
  ERROR_CODES: {
    BAD_REQUEST_ERROR: 400,
    INTERNAL_SERVER_ERROR: 500,
    AUTHENTICATION_ERROR: [401, 403],
  },
  USER_STATE: {
    LOGGED_USER: "logged",
    ANONYMOUS_USER: "anonymous",
  },
  PARENT_COMPONENTS_LIST: {
    ORDER_DETAILS: "OrderDetails",
  },
  PAYMENT: {
    SUCCESS_CODE: "870",
    NUM_YEARS: 16,
  },
  ORDER_STATUS_SHIPPED: "Shipped",
  DELETE_INACTIVE_MYFOLDER_AFTER: 30,
  ERROR_MESSAGE: {
    GENERAL: "Something went wrong. Please try again...",
    SESSION_TIMEOUT_MSG: "Your session is expired.. Please login again...",
    SESSION_TIMEOUT_SECURE_PAGE_MSG:
      "Redirecting to Home Page due to inactivity",
  },
  COLOR_FILE_URL: "https://kohler.scene7.com/is/image/PAWEB/", // TODO: Obtain value from config
  CT_API_URL: "https://api.us-central1.gcp.commercetools.com", // TODO: Obtain value from config
  CT_PROJECT_KEY: "kohler-na-qa-1", // TODO: Obtain value from config
  CT_SALES_CHANNEL: "KOUS", // TODO: Obtain value from config
  REGEX_TEXT: /^[a-z\d\-,'"\s]+$/,
  REGEX_ALPHANUMERIC_SAFE_CHARS: /^[a-z\d\-,'"\s]+$/i,
  REGEX_PASSWORD: new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{11,})"
  ),
  REGEX_EMAIL:
    /^((?!\.)(?!\-)(?!\_)[a-z0-9]*([\.\-\_]?[a-z0-9\-]*)?[^\-`_.#()+/=!@$%^&*:'"<>])(@(?!\.)(?!\-)(?!\_)[\w-]+)(\.\w+(\.\w+)?[^.\W])$/i,
  KEYCODE: { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 },
  KEY: { ENTER: "Enter", ESC: "Escape" },
  FF_PERSONA: "US_Kcom_FriendsNFamily:FF",
  KEMP_PERSONA: "US_Kcom_KohlerCoAssociate:KEMP",
  KF_FORCE_RENEW_TOKEN: "kf-okta-force-renew-token",
  KF_UPDATE_MEMBERSHIP: "kf-update-membership",
  CREATE_ACCOUNT_TYPE: {
    HOME_OWNER: "homeowner",
    PROFESSIONAL: "professional",
    TRADE_ACCOUNT: "trade",
  },
  UNDEFINED: "undefined",
  COMPONENT: {
    PAIRS_WELL_WITH: "pairsWellWith",
  },
  SLICK: {
    DEFAULT_DELAY: 5000,
    COUNT_OFFSET: 22,
    ARROW_OFFSET: 52,
  },
  CURRENCY_SIGN: "$",
  STATUS: {
    OK: 200,
    PAGE_NOT_FOUND: 404,
    INTERNAL_SERVER_ERROR: 500,
  },
}
const favoritesEndPoint = "/shopping-list/Favorites"

const createFavoritesEndPoint = "/shopping-list/create"

const addFavoritesEndPoint = (id, type) => {
  return `/shopping-list/add/${id}?type=${type}`
}

const removeFavoritesEndPoint = id => {
  return `/shopping-list/remove/items/${id}`
}
const SWATCH_NA = "swatch_NA"
const ADD_10_MINUTES = 600000
const PRIVACY_COOKIE_CLICKED = "is_privacy_cookie_clicked"
const GLOBAL_CONFIGURATION_PATH =
  "/bin/kohler/services/globalconfig.annsacks.json"
const DOMAIN = process.env.NEXT_PUBLIC_GLOBALCONFENV
const GLOBAL_CONFIGURATION_ENDPOINT = DOMAIN + "/api/globalconfig"
const LEAD_TIME_DOCUMENT_ENDPOINT = DOMAIN + "/bin/kohler/services/content"
const locationZipEndPoint = "/maps/location/zipcode/"
const STORE_MIN_DISTANCE = 64
const STORE_MAX_DISTANCE = 1000
const LOCATION_API_TRIGGER_INTERVAL = 1800000 // 30mins
const STORE_DETAILS_API_ENDPOINT = DOMAIN + "/api/storedetails"
const DEFAULT_STORE_DETAILS_API_PATH = "/bin/kohler/services/storedetails?path="
const GET_PROFILE_ENDPOINT = "/customer/me"
const ZIP_FILE_DOWNLOAD_ENDPOINT = "/catalog/zip-file-download"
const SEARCH_PLP_ENDPOINT = "search/plp"
const MY_ACCOUNT_PATH = "/my-account"
// cart Dicount
const stopedByPreviousDiscount = "ApplicationStoppedByPreviousDiscount"
const maxAppReached = "MaxApplicationReached"
const emailSubscribeEndPoint = "/crm/newsletter/subscription"
const TOAST_MESSAGE_DEFAULT_DURATION = 5000 // 5seconds
const editAddressEndPoint = "customer/address"
const FIND_MY_ORDERS_ENDPOINT = "/checkout/orders/query"
const FIND_MY_ORDERS_V1_ENDPOINT = "/checkout/orders/v1/query"
const SPLIT_ORDER = "checkout/ordersplit"
const GET_GUEST_TOKEN_ENDPOINT = DOMAIN + "/api/token"
const KEY_SPECIFIER_QUERRY_SELECTOR_URL = 'a[href="#KeySpecifier"]'
const KEY_SPECIFIER_API_URL_ENDPOINT = "/membership/assign/persona"
const MEMBERSHIP_API_URL_ENDPOINT = "/membership/kohler-associate/entry"
const MEMBERSHIP_QUERRY_SELECTOR_URL = 'a[href="#AssociateMembership"]'
const MORE_OPTIONS = {
  LEARN_MORE: "Learn More",
  EXPLORE_MORE: "Explore More",
  FREE_QUOTE: "Get a FREE Quote",
}
const DEFAULT_SCROLL = {
  scroll: 60,
  backToTop: 20,
  freeQuote: 120,
}
// order confirmation
const orderConstants = {
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  CREDIT_CARD: "CREDIT_CARD",
  PAYPAL: "PP",
  SHIPPED: "Shipped",
}
const GET_ORDER_DETAILS_ENDPOINT = "checkout/orders"
const DEFAULT_CARD_DETAILS_API_PATH =
  "/bin/kohler/services/list?path=/content/annsacks"
const MY_SERVICES_ENDPOINT =
  "/shopping-list/MyServices?lang=" + process.env.NEXT_PUBLIC_LOCALE

const MY_FAVORITES_ENDPOINT =
  "/shopping-list/Favorites?lang=" + process.env.NEXT_PUBLIC_LOCALE
export const BOOLEAN_VALUE_RESPONSE = [
  "InStoreShopping",
  "VirtualMeetings",
  "WeekendHours",
  "SlabGallery",
  "AppointmentOnly",
]

const COMPONENT_TYPES = {
  AEMFORM: "aemform",
  PRODUCTCARD: "productcard",
  ROOT_CONTAINER: "root",
  CONTAINER: "container",
  VIDEO: "video",
  AUTH_MODAL: "authmodal",
  NEWSLETTER: "newsletter",
  TEASER: "teaser",
  TEASER_V2: "teaser_v2",
  BLOGS_CAROUSEL: "blogs-carousel",
  BLOGS_LISTING: "blogs-list",
  CAROUSEL: "carousel",
  SLICK: "carousel-slick",
  SPACER: "spacer",
  TEXT: "text",
  TAB: "tab",
  BREADCRUMB: "breadcrumb",
  PRODUCTLIST: "productlist",
  SEARCH: "search/v2/search",
  EMBED: "embed",
  BRAND_SWITCHER: "brand-switcher",
  UTILITY_NAV_HEADER: "utilitynavheader",
  UTILITY_WIDGET: "utilitywidget",
  TABS: "tabs",
  IMAGE: "image",
  SITEWIDE_WARNING: "sitewide-warning",
  IMAGEV3: "image/v3/image",
  CAROUSELSLICK: "carousel-slick",
  TOASTER: "toaster/v1/toaster",
  COMPARE_PRODUCTS: "compareproducts",
  MAIN_FOOTER: "mainfooter",
  ADDITIONAL_FOOTER: "additionalfooter",
  NEWSLETTER_SIGNIN: "newslettersignin",
  NEWSLETTER_SIGNUP: "newslettersignup",
  CART_LANDING: "cart-landing",
  CHECKOUT: "checkout",
  ORDER_CONFIRMATION: "orderconfirmation",
  ORDER_STATUS: "orderstatus",
  ORDER_HISTORY: "orderhistory",
  ORDER_DETAILS: "orderdetails",
  SHARED_CART: "sharedcart",
  PAIRS_WELL_WITH: "pairs-well-with",
  HELPSUPPORT: "help-support",
  GLOBAL_NAVIGATION: "globalnavigation",
  PROMOBANNER: "plp-promo-banner",
  ACCOUNT_SETTINGS: "accountsettings",
  MY_SERVICES: "myservices",
  MY_FAVORITES: "myfavorites",
  CHANGE_PASSWORD: "changepassword",
  MY_PRODUCTS: "myproducts",
  PRODUCT_DETAILS: "asproductoverview",
  PRODUCT_TAB_DETAIL: "asproducttabdetail",
  PRODUCT_DETAILS_ACCORDION: "accordion",
  PRODUCT_DETAILS_EXFPDP: "exfpdp/v1/exfpdp",
  PRODUCT_DETAILS_REVIEW: "components/review",
  REGISTER_OFFLINE_PRODUCTS: "register-offline-products",
  REGISTER_ONLINE_PRODUCTS: "register-online-products",
  KNOWLEDGE_ARTICLE: "knowledge-article/v1/knowledge-article",
  BROWSE_ALL_STORES: "browse-all-stores",
  FIND_A_SHOWROOM_LANDING: "findstorelandingv2",
  STORE_FILTER: "storefilter",
  LITERATURE: "literature",
  CONTACT_US: "contactus",
  FINDING_MODEL_NUMBER: "finding-model-number",
  TECHNICAL_SPECIFICATION: "technicalspecs",
  PRESS_LANDING: "press-release-landing",
  UPSELL_CONTAINER: "container-up-sell",
  FIND_STORE: "findstore",
  INPAGE_SEARCH: "in-page-search",
  TITLE: "title",
  KEY_SPECIFIER: "key-specifier",
  DYNAMIC_SEARCH: "dynamicsearch",
  ASSOCIATE_MEMBERSHIP: "associate-membership",
  INSPIRE_VIDEO: "inspire-video",
  BUTTON: "button",
  Lead_Generation: "leadgenform",
  INSPIRATION_LANDING: "inspiration-landing",
  INSPIRATION_DETAIL: "inspiration-detail",
  PRESS_LANDING: "press-release-landing",
  MANUALPDP: "annsacks/components/manualPdpSummary",
  MANUALPDP_TABS: "annsacks/components/manualPdpTabs",
  AS_PRODUCT_LISTING: "annsacks/components/productlist",
  Trade_Membership: "trademembership",
  LIST:"list"
}
const DISABLE_SROLL_PATH = [
  "home-energy/home-generators",
  "buying-guides/bath-tub-buying-guide",
  "services/installation-services",
]

const FRAGMENT_TYPES = {
  HEADER: "header",
  MAIN: "main",
  FOOTER: "footer",
}

const VIDEO_EVENTS = {
  PLAY: "play",
  PAUSE: "pause",
  ENDED: "ended",
}

const TAB_WIDTH = 768
const DESKTOP_WIDTH = 1280
const ROW_COLUMN_MIN_WIDTH = 1025

// PLP
// sort constants
const KEYCODE = { ENTER: 13, ESC: 27, SPACE: 32, UP: 38, DOWN: 40, TAB: 9 }
// Find a store
export const FINDLOCATIONKEYCODE = { LEFTARROW: 37, RIGHTARROW: 39 }
export const LOCATIONSCONST = {
  LocationType: "KOHLER Store",
  paramSpatialFilter: 161,
  status: 200,
}
// press room
export const PRESS_ROOM_PATH = "/en/press-room"
// Filter
const queryParamsToPersist = ["sort", "keyword", "tab"]

const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME = 9
const PLP_END_POINT = "/apirequest/search/v1/plp"
const PLP_END_POINT_SUBSCRIPTION_KEY = "/apirequest/lw/plp"
const PDP_END_POINT_SUBSCRIPTION_KEY = "/lw/v1/pdp/product"
const apimSubscriptionKey = process.env.APIM_SUBSCRIPTION_KEY
const PLP_END_POINT_CLIENT = "/search/v1/plp"
const HELP_FAQ_END_POINT = "/search/plp"
const DEFAULT_PRODUCT_COUNT_PLP = 30
const DEFAULT_TECHNICAL_SPECT_COUNT = 30
const TECHNICAL_SPECT_SEARCH_COUNT = 5

const PROFILE_END_POINT_CLIENT = "/search/v1/profile"

const debounceThresholdCheckUserExists = 500

const customActivityEvents = ["click", "keydown"]

const PAGE_TYPES = {
  CATEGORY_LANDING_PAGE: "category landing page",
}
const PRODUCTS_PER_PAGE = [30, 60, 90]
const imgPlaceholderData =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
// Account Settings constants
const EDIT_PROFILE_ENDPOINT = "/customer/profile"
const DELETE_ACCOUNT_ENDPOINT = "/customer/account"
const CHANGE_ACCOUNT_PASSWORD_ENDPOINT = "/customer/change_password"
export const EMPTY_PIXEL =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
export const FULL_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjNweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjMgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+RmF2b3JpdGVzIEJsYWNrIGZpbGxlZCBJY29uPC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJGYXZvcml0ZXMtQmxhY2stZmlsbGVkLUljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDk5OTcyLCAwLjUwMDAwMCkiIGZpbGw9IiM0OTQ5NDkiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xLjY5NDYxMTg5LDEuNjk1NTU5NDQgQy0wLjUwMTg5NzgzLDMuODk3MDQ5NDMgLTAuNTcwMjc5NjkxLDcuNDU1ODUwMTEgMS41MzEyODgxMyw5LjcwOTk2MzkgTDEuNjg4MjMwMDEsOS44NzMxOTUyIEwxMS4wMDE3MDE4LDE5LjIwNzkwMTYgTDIwLjI4Mzc4NTQsOS45MDUxNTEyIEwyMC40NDExNTc3LDkuNzQyNTQ2OCBDMjIuNTY5NTIwNiw3LjQ2MDMwODEzIDIyLjUwOTU1NjcsMy45MDEzNjA3OSAyMC4zMDg3NDU0LDEuNjk1NTU5NDQgTDIwLjEyMjgzOTUsMS41MTcyMDk4NyBDMTcuODU2NDMxMywtMC41NjM1MzUwOTUgMTQuMzM0NTc5MiwtMC41MDQwODUyMzkgMTIuMTM5OTEwNiwxLjY5NTU1OTQ0IEwxMS4wMDEwMjgsMi44MzYgTDkuODYzNDQ2NjMsMS42OTU1NTk0NCBDNy42Njg3NzgwNCwtMC41MDQwODUyMzkgNC4xNDY5MjYwMiwtMC41NjM1MzUwOTUgMS44ODA1MTc3NywxLjUxNzIwOTg3IEwxLjY5NDYxMTg5LDEuNjk1NTU5NDQgWiIgaWQ9IkZhdm9yaXRlcy1JY29uIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

export const EMPTY_FAVORITE_BASE64 =
  "data:image/svg+xml;base64,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"

const TABS_NOT_REQUIRED_GRIDICON = [
  "inspiration",
  "technical",
  "resources",
  "help",
]
// myProducts endPoints
const MY_PRODUCT_SEARCH_CATALOG = "/search/full-catalog"
const MY_PRODUCT_PRODUCT_REGISTRATION = "/crm/product/registration"
const PDP_TEASER_DETAILS = DOMAIN + "/api/pdpTeaserDetails"
const PLUMBING_SERVICE_PARTS = "PlumbingServiceParts"
const PARTS = "parts"

// contact us endpoints
const CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT = "/crm/webtocase"

export const API_SUCCESS_STATUS = "succeeded"
export const API_FAILURE_STATUS = "failed"
export const PDP_DEFAULT_IMAGE = process.env.PDP_DEFAULT_IMAGE

export const EMBED_TYPE_SCRIPT = "SCRIPT"
export const EMBED_TYPE_HTML = "HTML"
export const VISUALICON_ARIA_LABEL = "View at 360 degree mode"
export const MATTERPORT_ARIA_LABEL = "virtual tour popup"

// tab component constants
export const NS = "cmp"
export const IS = "tabs"
export const keyCodes = {
  END: 35,
  HOME: 36,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
}
export const selectors = {
  self: "[data-" + NS + '-is="' + IS + '"]',
  active: {
    tab: "cmp-tabs__tab--active",
    tabpanel: "cmp-tabs__tabpanel--active",
  },
}

// privacy-policy constants
export const PRIVACY_ASPATH = "privacy-policy"

// press room constants
export const DOWNLOAD_SPINNER = "download-spinner"
export const postOrderNoOfDays = 45
export const TotalSecsForaDay = 86400000
// teasercaption-repositioning constants
export const TEASER_CAPTION_CLASSES =
  ".teaser.img-right-caption-left, .history-module-vertical-image.image-right, .history-module-with-SQR-img.image-left, .img-caption-style-left.img-right-with-number__intend, .img-caption-style-left.img-right-with-number"
// Add conditional wrapper in AEMGRID component for the provided grouped elements.
export const groupedComponents = [
  COMPONENT_TYPES?.BREADCRUMB,
  COMPONENT_TYPES?.CAROUSEL,
  COMPONENT_TYPES?.CONTAINER,
]
export const SUCCESS = "success"
// Product support center constants
export const SUPPORT_CENTER_PATH = "/en/support/product-support-center"
const SAMPLE = "sample"
export const INSPIRATION_LANDING_PATH = "/en/inspiration/rooms-inspiration"
export {
  ROW_COLUMN_MIN_WIDTH,
  TAB_WIDTH,
  DESKTOP_WIDTH,
  authorBaseUrl,
  publisherBaseUrl,
  dataUrl,
  headerUrl,
  footerUrl,
  staticClasses,
  apiBaseUrl,
  oktaTokenEndpoint,
  getCartEndPoint,
  createCartEndPoint,
  getStockEndPoint,
  cartItemsEndPoint,
  shippingCostEndPoint,
  mergeCartEndPoint,
  SWATCH_NA,
  ADD_10_MINUTES,
  PRIVACY_COOKIE_CLICKED,
  GLOBAL_CONFIGURATION_PATH,
  GLOBAL_CONFIGURATION_ENDPOINT,
  locationZipEndPoint,
  STORE_MIN_DISTANCE,
  STORE_MAX_DISTANCE,
  LOCATION_API_TRIGGER_INTERVAL,
  STORE_DETAILS_API_ENDPOINT,
  DEFAULT_STORE_DETAILS_API_PATH,
  discountEndPoint,
  stopedByPreviousDiscount,
  maxAppReached,
  taxEndPoint,
  shareCartEndPoint,
  signupEndPoint,
  emailSubscribeEndPoint,
  deleteCartEndPoint,
  shipmentFromCartEndPoint,
  GET_PROFILE_ENDPOINT,
  addAddressEndPoint,
  addressSuggestionEndPoint,
  TOAST_MESSAGE_DEFAULT_DURATION,
  validateTokenEndPoint,
  editAddressEndPoint,
  searchPlpEndPoint,
  inPageSearchEndPoint,
  searchProfilePlpEndPoint,
  orderSubmitEndPoint,
  FIND_MY_ORDERS_ENDPOINT,
  FIND_MY_ORDERS_V1_ENDPOINT,
  checkSplitOrderEndPoint,
  cartDataUrl,
  checkoutDataUrl,
  orderConfirmationDataUrl,
  paymentEndPoint,
  payPalPaymentEndPoint,
  SPLIT_ORDER,
  orderConstants,
  GET_ORDER_DETAILS_ENDPOINT,
  DEFAULT_CARD_DETAILS_API_PATH,
  productBySkuEndPoint,
  findashowroomUrl,
  sharedCartUrl,
  recentlyViewedEndPoint,
  orderDetailsPageDataUrl,
  orderHistoryPageDataUrl,
  orderStatusPageDataUrl,
  baseUrl,
  findAStoreUrl,
  cartPage,
  favoritesEndPoint,
  COMPONENT_TYPES,
  FRAGMENT_TYPES,
  VIDEO_EVENTS,
  ZIP_FILE_DOWNLOAD_ENDPOINT,
  SEARCH_PLP_ENDPOINT,
  addFavoritesEndPoint,
  createFavoritesEndPoint,
  removeFavoritesEndPoint,
  KEYCODE,
  DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME,
  GET_GUEST_TOKEN_ENDPOINT,
  PLP_END_POINT,
  apimSubscriptionKey,
  PLP_END_POINT_SUBSCRIPTION_KEY,
  PDP_END_POINT_SUBSCRIPTION_KEY,
  PLP_END_POINT_CLIENT,
  DEFAULT_PRODUCT_COUNT_PLP,
  queryParamsToPersist,
  debounceThresholdCheckUserExists,
  customActivityEvents,
  PROFILE_END_POINT_CLIENT,
  PAGE_TYPES,
  PRODUCTS_PER_PAGE,
  accountSettingsPageDataUrl,
  MyServicePageDataUrl,
  MyProductsPageDataUrl,
  MY_SERVICES_ENDPOINT,
  MyFavoritesPageDataUrl,
  MY_FAVORITES_ENDPOINT,
  PRODUCT_DATA_TILE_URL,
  PRODUCT_DATA_TRIM_URL,
  PRODUCT_TILE,
  PRODUCT_TRIM,
  loveYourLookDataUrl,
  pageNotFoundDataUrl,
  REGISTER_OFFLINE_PRODUCTS_DATA_URL,
  searchDataUrl,
  imgPlaceholderData,
  EDIT_PROFILE_ENDPOINT,
  DELETE_ACCOUNT_ENDPOINT,
  CHANGE_ACCOUNT_PASSWORD_ENDPOINT,
  TABS_NOT_REQUIRED_GRIDICON,
  MY_PRODUCT_SEARCH_CATALOG,
  MY_PRODUCT_PRODUCT_REGISTRATION,
  REGISTER_ONLINE_PRODUCTS_DATA_URL,
  PDP_TEASER_DETAILS,
  authorPreviewBaseUrl,
  authorPreviewUserName,
  authorPreviewPassword,
  previewContentPrefix,
  FETCH_PRODUCT_REG_ENDPOINT,
  MY_PRODUCTS_ENDPOINT,
  PLUMBING_SERVICE_PARTS,
  PARTS,
  FAQ_PAGE_DATA_URL,
  browseAllStoresURL,
  HELP_FAQ_END_POINT,
  DEFAULT_TECHNICAL_SPECT_COUNT,
  LITERATURE_DATA_URL,
  CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT,
  MY_ACCOUNT_PATH,
  TECHNICAL_SPECIFICATION_DATA_URL,
  TECHNICAL_SPECT_SEARCH_COUNT,
  PRESS_LANDING_URL,
  FIND_STORE_URL,
  KEY_SPECIFIER_QUERRY_SELECTOR_URL,
  KEY_SPECIFIER_API_URL_ENDPOINT,
  MEMBERSHIP_API_URL_ENDPOINT,
  MEMBERSHIP_QUERRY_SELECTOR_URL,
  ARTICLE_CONTENT_END_POINT,
  ARTICLE_IMG_END_POINT,
  MORE_OPTIONS,
  DEFAULT_SCROLL,
  DISABLE_SROLL_PATH,
  SAMPLE,
  LEAD_TIME_DOCUMENT_ENDPOINT
}
export const SEAT_TYPES = ["Toilet Seats", "Bidet Seats"]
export const EXCLUDE_PAGES = ["/checkout"]
export const UTILITY_CONSTANTS = {
  FAVOURITES: "favourite",
  SHARE: "share",
  PRINT: "print",
  DOWNLOAD: "download",
}
export const TEASER_CLASSES = ["hero-banner-full-bleed-image", "hero-video-3-4"]

export const READY_TO_SHIP_LABEL = "READY TO SHIP"
export const SPECIAL_ORDER_LABEL = "SPECIAL ORDER"
export const SHIPS_IN_LABEL = "Ships in"
export const NON_STOCK_LABEL = "Non Stock"
export const IN_STOCK_LABEL = "In Stock"

export const ADD_TO_FAVORITES_MSG = "<p>This product has been saved to your <a href='/content/annsacks/us/en/my-account/my-favorites.html'>Favorites</a>.</p>"
export const REMOVE_FROM_FAVORITES_MSG = "<p>This product has been removed from your <a href='/content/annsacks/us/en/my-account/my-favorites.html'>Favorites</a>.</p>"

export const GEOLOCATION_ERROR_TITLE = "Can't Access Your Location";
export const GEOLOCATION_ERROR_MESSAGE =
  "We're sorry, but your browser is not set up to provide your location. To search using your location, please update your browser settings to share your location, or manually enter your zip code.";

export const SET_AS_MY_SHOWROOM_LABEL = "Set as my showroom";

export const SELECT_YOUR_STYLE_NOTE =
  "Please note: Some styles are not shown. To view all available color options, ";

export default CONSTANTS
export * from "./BrandConstants"
